import BasicFilterSelect from "../../../../../common/BasicFilterSelect";

export default function AddCustomFieldFilterSelect({customFields, onChange, loadingOptions}) {

    return(
        <BasicFilterSelect
            placeholder={'Select custom field'}
            options={customFields}
            onChange={onChange}
            loadingOptions={loadingOptions}
        />
    )
}